import dayjs from 'dayjs';

/**
 * Formats an ISO timestamp (the `lastUpdated` DATETIME attribute) for display,
 * e.g. `"2026-07-21T16:00:00Z"` -> `"21 Jul 2026, 16:00"`.
 *
 * Returns an empty string for missing or unparseable values.
 */
export const formatLastUpdated = (value?: string): string => {
  if (!value) return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD MMM YYYY, HH:mm') : '';
};
